(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const initStickyBar = (bar) => {
    if (bar.dataset.initialized === 'true') return;
    bar.dataset.initialized = 'true';

    const productRoot = document.getElementById(bar.dataset.productRootId);
    const stickyButton = bar.querySelector('[data-sticky-atc-button]');
    const stickyPrice = bar.querySelector('[data-sticky-atc-price]');
    let observedButton = null;
    let sourceIsVisible = false;

    if (!productRoot || !stickyButton || !stickyPrice) return;

    const getSourceButton = () => document.getElementById(bar.dataset.sourceButtonId);
    const getPriceText = () => {
      const priceRoot = document.getElementById(bar.dataset.priceId);
      if (!priceRoot) return '';

      const salePrice = priceRoot.querySelector('.price__sale .price-item--last');
      const regularPrice = priceRoot.querySelector('.price__regular .price-item--regular');
      return (salePrice || regularPrice)?.textContent?.trim() || '';
    };

    const setVisibility = () => {
      const shouldShow = mobileQuery.matches && !sourceIsVisible;
      bar.hidden = !shouldShow;
      document.body.classList.toggle('magcheer-sticky-atc-visible', shouldShow);
    };

    const intersectionObserver = new IntersectionObserver((entries) => {
      sourceIsVisible = entries.some((entry) => entry.isIntersecting);
      setVisibility();
    }, { threshold: 0.1 });

    const sync = () => {
      const sourceButton = getSourceButton();
      if (!sourceButton) return;

      if (sourceButton !== observedButton) {
        if (observedButton) intersectionObserver.unobserve(observedButton);
        observedButton = sourceButton;
        intersectionObserver.observe(sourceButton);
      }

      stickyButton.disabled = sourceButton.disabled;
      const sourceLabel = sourceButton.querySelector('span');
      if (sourceLabel?.textContent.trim()) stickyButton.textContent = sourceLabel.textContent.trim();

      const priceText = getPriceText();
      if (priceText) stickyPrice.textContent = priceText;
      setVisibility();
    };

    stickyButton.addEventListener('click', () => {
      const sourceButton = getSourceButton();
      if (sourceButton && !sourceButton.disabled) sourceButton.click();
    });

    const mutationObserver = new MutationObserver(sync);
    mutationObserver.observe(productRoot, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['disabled', 'class']
    });

    mobileQuery.addEventListener('change', setVisibility);
    sync();
  };

  const init = () => document.querySelectorAll('[data-magcheer-sticky-atc]').forEach(initStickyBar);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
